import type ComponentBlockInterface from '~/constants/interfaces/component-block-interface';
import { type ContentData } from '~/constants/types/component-block';

export default class ComponentBlock implements ComponentBlockInterface {
  data: ContentData;

  constructor(props: ContentData) {
    this.data = props;
  }

  get articleFilters() {
    return this.data.article_filter;
  }

  get wysiwygSize() {
    return this.data.size ?? '3/4';
  }

  get articles() {
    return this.data.articles;
  }

  get author() {
    return this.data.author;
  }

  get backgroundColor() {
    return this.data.background_color;
  }

  get backgroundPosition() {
    return this.data.background_position;
  }

  get backgroundType() {
    return this.data.background_type;
  }

  get blocks() {
    return this.data.blocks;
  }

  get button() {
    return this.data.button;
  }

  get buttonColorTheme() {
    return this.data.button_color_theme;
  }

  get column1() {
    return this.data.column_1;
  }

  get column2() {
    return this.data.column_2;
  }

  get content() {
    return this.data.content;
  }

  get contentType() {
    return this.data.content_type;
  }

  get color() {
    return this.data.color;
  }

  get feed() {
    return this.data.feed;
  }

  get gallery() {
    return this.data.gallery;
  }

  get image() {
    return this.data.image;
  }

  get imageUrl() {
    return this.data.image.url;
  }

  get imageText() {
    return this.data.image_text;
  }

  get label() {
    return this.data.label;
  }

  get layout() {
    return this.data.layout;
  }

  get layoutType() {
    return this.data.layout_type;
  }

  get link1() {
    return this.data.link_1;
  }

  get link2() {
    return this.data.link_2;
  }

  get link3() {
    return this.data.link_3;
  }

  get link4() {
    return this.data.link_4;
  }

  get link5() {
    return this.data.link_5;
  }

  get link() {
    return this.data.link;
  }

  get links() {
    return this.data.links;
  }

  get linkTitle() {
    return this.data.link.title;
  }

  get numberList() {
    return this.data.number_list;
  }

  get organization() {
    return this.data.organization;
  }

  get previewImage() {
    return this.data.preview_image;
  }

  get previewText() {
    return this.data.preview_text;
  }

  get quotes() {
    return this.data.quotes;
  }

  get quote() {
    return this.data.quote;
  }

  get questions() {
    return this.data.questions;
  }

  get showColumnContent() {
    return this.data.show_column_content;
  }

  get showFilter() {
    return this.data.show_filter;
  }

  get title() {
    return this.data.title;
  }

  get videoEmbedded() {
    return this.data.embedded;
  }

  get video() {
    return this.data.video;
  }

  get videoType() {
    return this.data.video_type;
  }

  get products() {
    return this.data.products;
  }

  get product() {
    return this.data.product;
  }

  get gravityForm() {
    return this.data.gravity_form;
  }

  get labelAsH1() {
    return !!this.data.label_as_h1;
  }

  get script() {
    return this.data.script;
  }

  get showExcerpt() {
    return this.data.show_excerpt === '1';
  }

  get gridPosition() {
    return Number(this.data.grid_position);
  }

  get rating() {
    return Number(this.data.rating);
  }

}
